import React from 'react';
import { useDispatch } from 'react-redux';
import LogoAlif from '../components/LogoAlif/LogoAlif';
import { setLanguage } from '../../reducers/language';
import './topBar.scss';

export const LandingTopBar = () => {
  const dispatch = useDispatch();

  const getLangChange = (e) => {
    dispatch(setLanguage(e.target.value));
  };

  return (
    <>
      <div className="top-bar desktop  ">
        <div className="container top-navbar-container">
          <a className="navbar-brand" href="/">
            <LogoAlif />
          </a>
          <div
            className="select-language-div"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <div>
              <select className="language-div" onChange={getLangChange}>
                <option value="ru">RU</option>
                <option value="tj">TJ</option>
              </select>
            </div>
          </div>
        </div>
        <nav className="navbar navbar-expand-lg navbar-light"></nav>
      </div>
    </>
  );
};
